/**
 * Cliente HTTP de Mensajes: wrappers tipados sobre `req()` de campana-nueva. Nunca se manda el comercio (sale del
 * token). Es del equipo: con el token de una persona de un cliente, el backend dice 403.
 */

import { req } from "../campana-nueva/api";
import type { Resp } from "../wa-oficial/api";
import type * as T from "./types";

const ruta = (id: string) => `/activa/segmentaciones/${encodeURIComponent(id)}/mensajes`;

export const mensajesApi = {
  ver: (id: string): Promise<Resp<T.VistaDeMensajes>> => req("GET", ruta(id)),
  guardar: (id: string, grupos: T.MensajeParaGuardar[]): Promise<Resp<T.Guardado>> => req("PUT", ruta(id), { grupos }),
  previa: (id: string, pedido: T.PedidoDePrevia): Promise<Resp<T.Previa>> => req("POST", `${ruta(id)}/previa`, pedido),
  /** «Escribir con IA»: una propuesta para el grupo. No guarda ni manda nada */
  ia: (id: string, pedido: T.PedidoDeIa): Promise<Resp<T.RespuestaIa>> => req("POST", `${ruta(id)}/ia`, pedido),
  /**
   * «Crear las plantillas en Meta»: crea y manda a aprobar la plantilla de cada grupo de WhatsApp con su propuesta guardada
   * (o de los `grupos` pedidos), y se la pone al grupo con el mapeo propuesto. Sólo con el pedido del operador
   */
  plantillas: (id: string, pedido: { grupos?: string[] } = {}): Promise<Resp<T.RespuestaDePlantillas>> => req("POST", `${ruta(id)}/plantillas`, pedido),
};
